import {useEffect, useRef} from 'react';

import type {SpotAiScreenViewName} from '@modules/analytics/events';
import {canTrackScreenView} from '@modules/analytics/events';
import {useLogEvent} from '@providers/LogEventProvider';

type TrackScreenViewOptions = {
	pageTitle?: string;
	requireUserId?: boolean;
};

export const useTrackScreenView = (
	screenViewName: SpotAiScreenViewName,
	score?: number | null,
	options: TrackScreenViewOptions = {},
): void => {
	const {isReady, trackScreenView, userId} = useLogEvent();
	const trackedKeyRef = useRef<string | null>(null);
	const {pageTitle, requireUserId = false} = options;

	useEffect(() => {
		if (!isReady || !canTrackScreenView(screenViewName, score)) return;
		if (requireUserId && !userId) return;

		const key = `${screenViewName}:${score ?? ''}:${pageTitle ?? ''}:${
			requireUserId ? userId : ''
		}`;
		if (trackedKeyRef.current === key) return;
		trackedKeyRef.current = key;

		void trackScreenView({screenViewName, score, pageTitle});
	}, [
		isReady,
		pageTitle,
		requireUserId,
		screenViewName,
		score,
		trackScreenView,
		userId,
	]);
};
